import React, { useContext, useEffect, useState } from "react";
import { IoSend } from "react-icons/io5";
import axios from "axios";
import { AppContext } from "../context/AppContext";
import Loader from "../components/Loader";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import newlogo from "../assets/images/newlogo.webp";

const ToDo = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  const { notifySuccess, notifyError } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  //
  const getToDo = async () => {
    try {
      const token = await dispatch(getToken());
      setLoading(true);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/SML_Portal`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );
      if (res.status === 200) {
        const data = res.data.data;
        data.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key] = item[key] ?? "";
            //
            if (key === "Created_Time") {
              const date = new Date(item[key]);
              const formattedTime = date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              });
              item[key] = formattedTime;
            }
            //
            item.reply = "";
          });
        });
        //
        const filtered = data.filter((item) => {
          return item.Client_Comments === "";
        });
        setData(filtered);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getToDo();
    }
  }, [user]);
  //
  const handleInputs = (e, index) => {
    const updatedData = data.map((item, ind) =>
      index === ind
        ? Object.assign(item, { [e.target.name]: e.target.value })
        : item
    );
    setErrorId("");
    setData(updatedData);
  };
  const [errorId, setErrorId] = useState("");
  const sendReply = async (item, index) => {
    if (item.reply === "") {
      setErrorId(index);
    } else {
      const token = await dispatch(getToken());
      const data = [
        {
          Client_Comments: item.reply,
          id: user.id,
        },
      ];
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SML_Portal/${item.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );
      if (res.status === 200) {
        notifySuccess("Message sent!");
        setTimeout(() => {
          getToDo();
        }, 2000);
      } else {
        notifyError("Something went wrong");
      }
    }
  };
  return (
    <div>
      <Title title={"To Do"} />
      {loading ? (
        <Loader message="Loading ToDo..." color="black" />
      ) : (
        <>
          {data.length === 0 ? (
            <p className="text-center">No ToDo found</p>
          ) : (
            <>
              {data.map((item, index) => {
                return (
                  <div key={index}>
                    <hr />
                    <div className="text-center text-muted mb-2">
                      <small>{item.Title}</small>
                    </div>
                    <div className="convo-flex">
                      <div className="convo-user-pic">
                        <img src={newlogo} alt="" />
                      </div>
                      <div>
                        <p className="mb-2">Settle My Loan</p>
                        <div className="convo-box">
                          <p>{item.Agent_Comments}</p>
                          <div className="text-end">
                            <small className="text-muted">
                              {item.Created_Time}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="convo-reply-flex">
                      <input
                        type="text"
                        className="input"
                        name="reply"
                        onChange={(e) => handleInputs(e, index)}
                      />
                      <button
                        className="button flex-button"
                        onClick={() => sendReply(item, index)}
                      >
                        Reply <IoSend />
                      </button>
                    </div>
                    <div className="text-end">
                      {errorId === index ? (
                        <small className="text-danger">Error</small>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ToDo;
